module.exports = __webpack_public_path__ + "static/media/footer-location.dbc916ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/pullman/home/footer-location.svg
// module id = 1249
// module chunks = 0